module.exports = __webpack_public_path__ + "img/LogoDashboard-28.321936b6.svg";